import { isAxiosError } from 'axios';

// The API answers a rejected request with `{ errors: [{ message, field? }] }`.
// The first message is the one worth showing; anything else falls back to
// the caller's generic text.
export function serverErrorMessage(error: unknown, fallback: string): string {
  if (!isAxiosError(error)) {
    return fallback;
  }
  const errors = (error.response?.data as { errors?: { message?: unknown }[] })
    ?.errors;
  const message = errors?.[0]?.message;
  return typeof message === 'string' && message !== '' ? message : fallback;
}
